import React, { useEffect } from 'react'
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link } from 'react-router-dom'
import { MdNavigateNext } from 'react-icons/md'
import { Button, Grid, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableHead, TableRow, TextField, } from '@mui/material';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { AccessLevel, subAdmin, useStyles } from '../../constant/constant';
import { useDispatch, useSelector } from 'react-redux';
import { addUserState, editsubAdmin,stateRefresh } from '../../slices/user';
import axios from 'axios';
import Swal from 'sweetalert2';
import { isEmpty } from 'lodash';
import moment from 'moment'
import { USER } from '../../constant/endpoint';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    height: '65%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    padding: '0px 30px',
    overflow: "auto",
    paddingBottom: "20px"
};


const SubAdmin = () => {
    const [open, setOpen] = React.useState(false);
    const [users, setUsers] = React.useState([]);
    const userAdmin = useSelector(state => state.userSlice)
    const login = useSelector(state => state.loginSlice)
    const dispatch = useDispatch()
    const classes = useStyles();
    const breadcrumbs = [
        <Link underline="hover" key="1" color="inherit" to={''} >
            <h4>Sub Admin</h4>
        </Link>, <h5>List</h5>
    ];
    const handleClose = () => setOpen(false);
    const handleOpen = () => {
        setOpen(true)
        dispatch(stateRefresh())
    };

    const handleField = (e) => {
        dispatch(addUserState({ name: e.target.name, value: e.target.value }))
    }
    const getSweetAlert = (type, topic) => {
        Swal.fire({
            position: 'top-end',
            icon: type,
            title: topic,
            showConfirmButton: false,
            timer: 3000
        })
    }
    const isValidation = () => {
        var status = true
        if (isEmpty(userAdmin.userState.name)) {
            getSweetAlert('error', 'Fill the name field')
            return status = false
        }
        if (isEmpty(userAdmin.userState.email)) {
            getSweetAlert('error', 'Fill the Email field')
            return status = false
        }
        // if (isEmpty(userAdmin.userState.password)) {
        //     getSweetAlert('error', 'Fill the Password field')
        //     if(userAdmin.userState.isEdit){
        //         return status
        //     }else{
        //         return status = false
        //     }
        // }
        // if ((userAdmin.userState.password.length <= 5)) {
        //     getSweetAlert('error', 'Password should be at least 6 characters')
        //     return status = false
        // }
        if (userAdmin.userState.access_level.length > 0) {
            getSweetAlert('error', 'Fill the Access Level field')
            return status = false
        }
        return status = true
    }
    const handleSubmit = async () => {
        if (isValidation()) {
            let response
            if(userAdmin.userState.isEdit){
                if(userAdmin.userState.password){
                    if(userAdmin.userState.password.trim() == ""){
                        delete userAdmin.userState.password
                    }
                }
                 response = await axios.patch(USER.replace(':user_id',userAdmin.userState._id), userAdmin.userState)
                 if (response?.data?.status === 'success') {
                    Swal.fire(`${userAdmin.userState.name} Edited Successfully`)
                    setOpen(false)
                    fetchUserList()
                }
            }else{
                response = await axios.post(USER.replace(':user_id',''), userAdmin.userState)
                if (response?.data?.status === 'success') {
                    Swal.fire('New Admin Added Successfully')
                    setOpen(false)
                    fetchUserList()
                }
            }
        }
    }
    useEffect(() => {
        fetchUserList()
    }, [])

    const fetchUserList = async () => {
        const response = await axios.get(USER.replace(':user_id',''), {
            headers: {
                'auth_token': `${login.token}`,
            }
        })
        if (response?.data?.status === 'success') {
            setUsers(response?.data?.data)
        }
    }
    const updateHandle = (data) => {
        setOpen(true)
        const adminData = {
            ...data,
            isEdit:true
        }
        dispatch(editsubAdmin(adminData))
    } 
    return (
        <>
            <div className="homeCard">
                <div className='subHomeCard'>
                    <Breadcrumbs
                        separator={<MdNavigateNext fontSize="small" />}
                        aria-label="breadcrumb"
                    >

                        {breadcrumbs}
                    </Breadcrumbs>
                    <Button variant={'contained'} color={'primary'} style={{ float: "right" }} onClick={handleOpen}>Add SubAdmin</Button>
                    <Box>
                        <Table className={classes.table} >
                            <TableHead>
                                <TableCell>Id</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Access Level</TableCell>
                                <TableCell>Registered At</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableHead>
                            <TableBody>
                                {
                                    users?.map((data,index) =>
                                        <TableRow>
                                            <TableCell>{index+1}</TableCell>
                                            <TableCell>{data.email}</TableCell>
                                            <TableCell>{data.name}</TableCell>
                                            <TableCell>{data.status ? <span style={{background:"green",padding:"5px",margin:"10px",color:"#fff",borderRadius:"5px"}}>Active</span> : <span style={{background:"red",padding:"5px",margin:"10px",color:"#fff",borderRadius:"5px"}}>InActive</span>}</TableCell>
                                            <TableCell>{data.access_level}</TableCell>
                                            <TableCell>{moment(data.createdAt).format('YYYY-MM-DD')}</TableCell>
                                            <TableCell><Button variant={'contained'} size='small' color={'warning'} onClick={()=>updateHandle(data)}>Update</Button></TableCell>
                                        </TableRow>
                                    )
                                }
                            </TableBody>
                        </Table>
                    </Box>
                </div>
            </div>

            <Modal
                open={open}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                onBackdropClick={() => setOpen(true)}
            >
                <Box sx={style} spacing={0.5} direction="row" useFlexGap flexWrap="wrap">
                    <h3>Add Sub Admin</h3>
                    <Grid container spacing={1}>
                        <Grid xs={12} item>
                            <label>Name</label><br></br>
                            <TextField style={{ width: "100%" }} id="outlined-basic" type='text' size={'small'} variant="outlined" name={'name'}  value={userAdmin.userState.name} onChange={handleField} />
                        </Grid>
                        <Grid xs={12} item>
                            <label>Email</label><br></br>
                            <TextField style={{ width: "100%" }} id="outlined-basic" type='email' size={'small'} variant="outlined" name={'email'} value={userAdmin.userState.email} autocomplete="off" onChange={handleField} />
                        </Grid>
                        
                        {
                            <Grid xs={12} item>
                            <label>Password</label><br></br>
                            <TextField style={{ width: "100%" }} id="outlined-basic" autocomplete="off"  type='password' size={'small'} variant="outlined" name={'password'} onChange={handleField} />
                        </Grid>
                        }
                        <Grid xs={12} item>
                            <label>Status</label><br></br>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Age"
                                style={{ width: "100%" }}
                                size={'small'}
                                name='status'
                                value={userAdmin.userState.status}
                                onChange={handleField}
                            >
                                <MenuItem value={true}>Active</MenuItem>
                                <MenuItem value={false}>InActive</MenuItem>
                            </Select>
                        </Grid>
                        {/* <Grid xs={12} item>
                            <label>Designation</label><br></br>
                            <Select labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Age"
                                style={{ width: "100%" }}
                                size={'small'}
                                name='role'
                                onChange={handleField}
                            >
                                {subAdmin.map((data) =>
                                    <MenuItem value={data}>{data}</MenuItem>
                                )}
                            </Select>
                        </Grid> */}
                        <Grid xs={12} item>
                            <label>Access Level</label><br></br>
                            <Select labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Age"
                                style={{ width: "100%" }}
                                size={'small'}
                                name='access_level'
                                onChange={handleField}
                                value={userAdmin.userState.access_level}
                            >
                                {AccessLevel.map((data) =>
                                    <MenuItem value={data.level_access}>{data.level_name}</MenuItem>
                                )}
                            </Select>
                        </Grid>
                        <Grid xs={9} mt={2}>
                            <Button color='error' onClick={handleClose} variant="contained">Cancel</Button>
                        </Grid>
                        <Grid xs={3} mt={2} textAlign={'right'}>
                            <Button variant="contained" onClick={handleSubmit}>Submit</Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </>
    )
}

export default SubAdmin